import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { ModalComponent } from 'app/core/components/modal/modal.component';
import { TYPE_MENU, TYPE_SCREEN } from 'app/core/models/constans.model';
import { DbService } from 'app/core/services/db.service';
import { COLLECTIONS_BD } from '../../../core/models/collections.model';
import { Restaurant } from '../../models/restaurants.model';
import { MenuStorageService } from '../../services/menu-storage.service';
import { MenuService } from './../../services/menu.service';

/**
 * Arma el menu del restaurante
 */
@Component({
    selector: 'app-menu',
    templateUrl: './menu.component.html',
    styleUrls: ['./menu.component.scss'],
    standalone: false
})
export class MenuComponent implements OnInit {
  /**
   * informacion del restaurante seleccionado
   */
  restaurant: Restaurant = {} as Restaurant;
  /**
   * Indica si se ve el componente home
   */
  viewPageHome: boolean | undefined;
  /**
   * Indica si se debe de ver los botones
   * de menus de sucursales asociadas
   */
  isShowBranchesButtons = false;
  /**
   * Color para las letras de slogan si es que
   * el restaurante lo tiene configurado
   */
  colorText = '';
  /**
   * Constantes de tipos de menu
   */
  readonly TYPES_SCREEN = TYPE_SCREEN;
  /**
   * Constructor
   *
   * @param db conexion con la BD
   * @param route ruta actual
   * @param menuStorage servicio de menu
   * @param router enrutador
   */
  constructor(
    private db: DbService,
    private route: ActivatedRoute,
    public menuStorage: MenuStorageService,
    private router: Router,
    private dialog: MatDialog,
    public menuService: MenuService,
  ) {
    this.menuService.getHome().subscribe((v: boolean) => {
      this.viewPageHome = v;
    });
    if (this.route.snapshot.params.lang) {
      this.menuService.setLang(this.route.snapshot.params.lang.toUpperCase());
    }
  }

  /**
   * Inicializa la informacion del restaurante
   */
  ngOnInit(): void {
    this.db.findOne(COLLECTIONS_BD.restaurants, this.route.snapshot.params.id).subscribe((restaurant: Restaurant) => {
      this.restaurant = restaurant;
      // if (this.restaurant.menuType === TYPE_MENU.oneMenu && !this.restaurant.branches) {
      //   this.openMenu('menu');
      //   return;
      // }
      // eslint-disable-next-line max-len
      //this.restaurant.imgFood = 'https://firebasestorage.googleapis.com/v0/b/sinmente-4bfad.appspot.com/o/uploads%2Frestaurants%2Fu1UtdMflGEfSP5nNvGO4%2Fmenu%2Fcocina%2FCARTAS%20PORTADA%20MAL%20DE%20OJO-08.jpgi1t9i07ns?alt=media&token=9fad17a2-d9cd-4526-acd2-ad5490060969';
      //TODO: Aqui se tiene que modificar el llamado al modal de mensaje
      if (restaurant.message) {
        this.dialog.open(ModalComponent, { disableClose: true, data: { title: 'Titulo', message: 'Contenido' } });
      }
      if (restaurant) {
        if (this.restaurant.linkTree && this.route.snapshot.url[1].path !== 'link') {
          window.location.href = this.restaurant.linkTree;
        }
        if (!this.restaurant.home) {
          this.menuService.setHome(false);
        }
        if (!this.restaurant.color) {
          this.restaurant.color = '#FFFFFFFF';
        } else {
          this.colorText = this.hexToRgb(this.restaurant.color).toString();
        }
        restaurant.id = this.route.snapshot.params.id;
        this.menuStorage.setRestaurant(restaurant);
      }
    });
  }

  /**
   * Abre el menu del departamento seleccionado
   * bar/cocina
   *
   * @param departament departamento seleccionado
   */
  openMenu(departament: string): void {
    this.router.navigateByUrl(`menu-detail/${this.route.snapshot.params.id}/${departament}`);
  }

  /**
   * Navega a la pantalla de menu del restaurante(sucursal) seleccionado
   *
   * @param id identificador del restaurante
   */
  navigateToMenu(id: string): void {
    this.db.findOne(COLLECTIONS_BD.restaurants, id).subscribe((restaurant: Restaurant) => {
      if (restaurant.menuType === TYPE_MENU.oneMenu) {
        this.router.navigateByUrl(`menu-detail/${id}/menu`);
      } else {
        this.router.navigateByUrl(`menu/${id}`).then(() => {
          location.reload();
        });
      }
    });
    ;
  }

  /**
   * Indica si se debe visualizar los botones de menu
   * y ocultar el home
   *
   * @returns true o false
   */
  viewMenuOptions(): boolean {
    if (!this.restaurant.home && !this.viewPageHome || this.restaurant.home && !this.viewPageHome) {
      return true;
    }
    return false;
  }

  /**
   * Indica si se debe visualizar el home y ocultar
   * los botones de menu
   *
   * @returns true o false
   */
  viewHome(): boolean {
    if (this.viewPageHome) {
      return true;
    }
    return false;
  }

  setHeightButton(): boolean {
    switch (this.restaurant.menuType) {
      case TYPE_MENU.threeMenu:
        return this.restaurant.brunchOff ? true : false;
      default:
        return false;
    }
  }

  /**
   * Convierte un color hexadecimal en el
   * color opuesto en rgb
   *
   * @param hex color en hexadecimal
   * @returns color en rgb
   */
  private hexToRgb(hex: string) {
    const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    if (result) {
      const r = 255 - parseInt(result[1], 16);
      const g = 255 - parseInt(result[2], 16);
      const b = 255 - parseInt(result[3], 16);

      return `rgb(${r},${g},${b})`;
    };
    return '#090909';
  }
}
